<template>
    <v-app>
        <flights-core-app-bar v-if="get_shared_Path === 'Flights'" v-model="expandOnHover" />
        <blocktimes-core-app-bar v-if="get_shared_Path === 'Blocktimes'" v-model="expandOnHover" />
        <airports-core-app-bar v-if="get_shared_Path === 'Airports'" v-model="expandOnHover" />
        <!-- <slotmanagement-core-app-bar v-if="get_shared_Path === 'Slotmanagement'" v-model="expandOnHover" :flights_dateRange="flights_dateRange" /> -->

        <flights-core-drawer :expand-on-hover.sync="expandOnHover" />

        <flights-core-view />

        <flights-core-footer />
        <div style="position: fixed; top: 78px; right: -35px;">
            <flights-core-settings
                v-if="get_shared_Path === 'Flights'"
                v-model="expandOnHover"
                style="padding-bottom:12px;" />
        </div>
        <div style="position: fixed; bottom: 65px; right: -35px;">
            <flights-core-slot-warnings
                v-if="get_shared_Path === 'Flights'"
                v-model="expandOnHover" />
        </div>
    </v-app>
</template>

<script>
    import { mapGetters } from 'vuex';


    export default {
        name: 'FlightsIndex',

        /* >>> *************************************************************** / /* Components */
        components: {

            FlightsCoreAppBar: () => import('./flights/components/core/AppBar'), // local
            BlocktimesCoreAppBar: () => import('./blocktimes/components/core/AppBar'), // local
            AirportsCoreAppBar: () => import('./airports/components/core/AppBar'), // local
            // SlotmanagementCoreAppBar: () => import('./slotmanagement/components/core/AppBar'), // local

            FlightsCoreDrawer: () => import('@/components/core/Drawer'),        // global
            FlightsCoreView: () => import('@/components/core/View'),            // global
            FlightsCoreFooter: () => import('@/components/core/Footer'),        // global

            FlightsCoreSettings: () => import('@/components/core/Settings'),    // global
            FlightsCoreSlotWarnings: () => import ('@/components/core/SlotWarnings') // global

        }, // eof components{}
        /* <<< ****************************************************************/

        /* >>> *************************************************************** / /* Props */
    props: {
            flights_dateRange: Array
        }, // eo props{}
        /* <<< ****************************************************************/


        /* >>> *************************************************************** / /* Data */
        data: () => ({

            expandOnHover: true

        }),
        /* <<< ****************************************************************/


		/* >>> *************************************************************** / /* Computed */
		computed: {

			...mapGetters([
                'get_shared_Path'
			])

		} // eo computed{}
		/* <<< ****************************************************************/

    };
</script>
